package fr.manyverse.app.infrastructure.monitoring

import io.github.jan.supabase.SupabaseClient
import io.github.jan.supabase.auth.auth
import io.github.jan.supabase.auth.status.SessionStatus
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.launch

/**
 * Rattache les événements Sentry à l'utilisateur Supabase connecté, pour pouvoir croiser un
 * rapport d'erreur avec les logs Supabase et les retours de `user_feedback`.
 */
class CrashReportingUserBinder(
    private val supabaseClient: SupabaseClient,
    private val crashReporter: CrashReporter,
    private val scope: CoroutineScope
) {
    fun start() {
        scope.launch {
            supabaseClient.auth.sessionStatus.collect { status ->
                when (status) {
                    is SessionStatus.Authenticated -> crashReporter.setUserId(status.session.user?.id)
                    is SessionStatus.NotAuthenticated -> crashReporter.setUserId(null)
                    // Chargement ou échec de rafraîchissement : l'utilisateur connu reste valable
                    is SessionStatus.Initializing, is SessionStatus.RefreshFailure -> Unit
                }
            }
        }
    }
}
